import React, {createContext} from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import UserStore from './store/UserStore';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { TonConnectUIProvider } from '@tonconnect/ui-react';

export const Context = createContext(null);


const store = new UserStore();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Context.Provider value={{
        user: store,
        auth: store.authStore,
        profile: store.profileStore,
        server: store.serverStore,
        chat: store.chatStore,
        log: store.logStore,
        player: store.playerStore
    }}>
        <TonConnectUIProvider manifestUrl="https://scraplands.ru/tonconnect-manifest.json">
            <App />
        </TonConnectUIProvider>
    </Context.Provider>
);